"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENDPOINT = exports.ICountry = exports.IEnv = void 0;
var uuid_1 = require("uuid");
var axios_1 = require("axios");
var version_json_1 = require("../version.json");
var report_1 = require("./report");
var constants_1 = require("./constants");
Object.defineProperty(exports, "IEnv", { enumerable: true, get: function () { return constants_1.IEnv; } });
Object.defineProperty(exports, "ICountry", { enumerable: true, get: function () { return constants_1.ICountry; } });
var utils_1 = require("./utils");
var ENDPOINT = /** @class */ (function () {
    function ENDPOINT(options) {
        this.options = options;
        this.support_webp = (0, utils_1.isSupportWebp)();
        options.env = String(options.env).toLowerCase();
        options.country = String(options.country).toUpperCase();
        window.localStorage && this.fetchStrategy('endpoint_strategy');
    }
    ENDPOINT.prototype.genAxiosInstance = function (timeout, times, delay) {
        return axios_1.default.create({
            timeout: timeout !== null && timeout !== void 0 ? timeout : 0,
            adapter: (0, utils_1.retryAdapterEnhancer)(axios_1.default.defaults.adapter, {
                times: times !== null && times !== void 0 ? times : 5,
                delay: delay !== null && delay !== void 0 ? delay : 60000
            })
        });
    };
    ENDPOINT.prototype.genHeader = function () {
        var requestId = (0, uuid_1.v4)().replace(/-/g, '');
        return {
            version: 1,
            sign: (0, utils_1.getSignature)(requestId, 101),
            request_id: requestId,
            biz: 101,
            app_version: 'mms-endpoint-' + version_json_1.version,
            sdk_version: 'mms-endpoint-' + version_json_1.version,
            os_type: 2,
            // device_id: 'WdtX5znKS85eth2cYU1q02bYFKgxGGZeJH2w/yGZffU=', // 客户端设备id，建议设置
            device_model: navigator.userAgent,
            // client_ip: '12.132.01.13', // 客户端ip，建议设置
            client_region: this.options.country,
            uid: this.options.uid // 用户ID，建议设置
            // network: 1, // 网络类型，1: WI-FI；2:蜂窝; 3:2G；4:3G；5:4G，6:5G，7:其他
            // os_version: '1.11.10', // 操作系统版本号
            // cpu_model: 'AArch64 Processor rev 2 (aarch64)', // CPU型号，建议设置
            // gpu_model: '' // GPU（显卡）型号，建议设置
        };
    };
    ENDPOINT.prototype.genReport = function () {
        this.report = new report_1.Report({
            country: this.options.country,
            biz: 101,
            env: this.options.env,
            sdkVersion: 'mms-endpoint-' + version_json_1.version,
            uid: this.options.uid,
            reportNoLimit: true
        });
    };
    ENDPOINT.prototype.filterData = function (data) {
        // 只有当status为0时，才更新配置
        var res = JSON.parse(localStorage.getItem('endpoint_strategy'));
        var endpoint_cron = data.endpoint_cron, md5s = data.md5s;
        res.endpoint_cron = endpoint_cron;
        res.md5s = md5s;
        var judgeFields = [
            'core_player',
            'livelog',
            'mms_detect',
            'mms_image',
            'mms_vod',
            'new_test',
            'rtc',
            'upload'
        ];
        judgeFields.forEach(function (item) {
            if (data[item] && data[item].status === 0) {
                res[item] = data[item];
            }
        });
        return res;
    };
    // 从服务端获取策略配置
    ENDPOINT.prototype.fetchStrategy = function (key) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function () {
            var _strategy, strategyCache, latitude, longitude, startTime, env, newMd5s, requestUrl, res, newData, mms_image, error_1, err, retry_count, actionId;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        this.genReport();
                        _strategy = JSON.parse(localStorage.getItem(key));
                        strategyCache = _strategy || JSON.parse(JSON.stringify(utils_1.defaultStrategy));
                        if (!(!_strategy ||
                            Date.now() - ((_a = _strategy === null || _strategy === void 0 ? void 0 : _strategy.endpoint_cron) === null || _a === void 0 ? void 0 : _a.pull_time) * 1000 >
                                ((_b = _strategy === null || _strategy === void 0 ? void 0 : _strategy.endpoint_cron) === null || _b === void 0 ? void 0 : _b.ttl))) return [3 /*break*/, 6];
                        latitude = 0, longitude = 0;
                        startTime = Date.now();
                        env = (_c = new Map([
                            [constants_1.IEnv.TEST, 'test.'],
                            [constants_1.IEnv.UAT, 'uat.'],
                            [constants_1.IEnv.LIVE, ''],
                            [constants_1.IEnv.STAGING, 'staging.'],
                            [constants_1.IEnv.TEST_STABLE, 'staging.']
                        ]).get(this.options.env)) !== null && _c !== void 0 ? _c : 'staging.';
                        if (!!ENDPOINT.lock) return [3 /*break*/, 5];
                        ENDPOINT.lock = true;
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 3, 4, 5]);
                        newMd5s = '';
                        if (localStorage.getItem('md5s') &&
                            localStorage.getItem('md5s') !== 'undefined') {
                            newMd5s = JSON.parse(localStorage.getItem('md5s'));
                        }
                        requestUrl = "https://endpoint.mms.".concat(env, "shopee.").concat((_d = constants_1.ICountryDomain[this.options.country]) !== null && _d !== void 0 ? _d : 'sg', "/api/v1/configs");
                        return [4 /*yield*/, this.genAxiosInstance(0, ((_e = _strategy === null || _strategy === void 0 ? void 0 : _strategy.endpoint_cron) === null || _e === void 0 ? void 0 : _e.max_retry_count) || 5, ((_f = _strategy === null || _strategy === void 0 ? void 0 : _strategy.endpoint_cron) === null || _f === void 0 ? void 0 : _f.fail_retry_period) || 6000).post(requestUrl, {
                                _header: this.genHeader(),
                                md5s: newMd5s || {}
                            })];
                    case 2:
                        res = _k.sent();
                        if (res.data.code === 0) {
                            localStorage.setItem('md5s', JSON.stringify(res.data.data.md5s));
                            newData = res.data.data;
                            if (JSON.parse(localStorage.getItem('endpoint_strategy'))) {
                                newData = this.filterData(res.data.data);
                            }
                            mms_image = newData.mms_image;
                            localStorage.setItem(key, JSON.stringify(newData));
                            this.report.GetEndpointCfgEvent({
                                actionId: 0,
                                cost: Date.now() - startTime,
                                triggerScene: 4,
                                ver: mms_image.data.ver,
                                retryCount: res.retry_count,
                                latitude: latitude,
                                longitude: longitude
                            });
                            this._strategy = newData;
                        }
                        else {
                            this._strategy = strategyCache;
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _k.sent();
                        if (error_1.err) {
                            err = error_1.err, retry_count = error_1.retry_count;
                            actionId = (_j = (_h = (_g = err === null || err === void 0 ? void 0 : err.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.code) !== null && _j !== void 0 ? _j : 500;
                            if ((0, utils_1.isTimeout)(err)) {
                                actionId = 1001;
                            }
                            this.report.GetEndpointCfgEvent({
                                actionId: actionId,
                                cost: Date.now() - startTime,
                                triggerScene: 4,
                                retryCount: retry_count,
                                latitude: latitude,
                                longitude: longitude
                            });
                        }
                        this._strategy = strategyCache;
                        return [3 /*break*/, 5];
                    case 4:
                        ENDPOINT.lock = false;
                        this.report.report();
                        return [7 /*endfinally*/];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this._strategy = _strategy;
                        _k.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ENDPOINT.prototype.getImgUrl = function (biz, imgid, suffix, opt) {
        if (imgid === void 0) { imgid = ''; }
        if (suffix === void 0) { suffix = ''; }
        return this.getImgUrlInternal(biz, imgid, suffix, true, opt);
    };
    ENDPOINT.prototype.getImgUrlV2 = function (biz, imgid, suffix, opt) {
        if (imgid === void 0) { imgid = ''; }
        if (suffix === void 0) { suffix = ''; }
        return this.getImgUrlInternal(biz, imgid, suffix, false, opt);
    };
    ENDPOINT.prototype.getImgUrlInternal = function (biz, imgid, suffix, checkId, opt) {
        if (imgid === void 0) { imgid = ''; }
        if (suffix === void 0) { suffix = ''; }
        var _strategy = (window.localStorage &&
            JSON.parse(localStorage.getItem('endpoint_strategy'))) ||
            utils_1.defaultStrategy;
        var configs = _strategy.mms_image.data.configs;
        var config = configs[biz] || configs[100];
        var _a = config.endpoint, _b = _a.disable, disable = _b === void 0 ? false : _b, _c = _a.default_suffix, default_suffix = _c === void 0 ? '' : _c, _d = _a.extend_suffix, extend_suffix = _d === void 0 ? '' : _d, _e = _a.domains, domains = _e === void 0 ? ['mms.img.susercontent.com'] : _e;
        if (disable) {
            // 2.0.3添加，用来控制调度比率
            return {
                ok: false,
                url: ''
            };
        }
        if (checkId && imgid.length !== 32) {
            return {
                ok: false,
                url: ''
            };
        }
        if (imgid.length === 0 || !domains.length) {
            return {
                ok: false,
                url: ''
            };
        }
        else {
            var urlStr = 'http://'; // 后续需要支持https时再添加
            var domainStr = domains[Math.floor(Math.random() * domains.length)];
            urlStr += "".concat(domainStr, "/").concat(imgid).concat(suffix);
            // 如果客户端(canvas判断+业务无disbale操作)+服务端(default_suffix字段下发）均确认可使用webp，才用.webp
            if ("".concat(default_suffix) === '.webp' &&
                !(opt === null || opt === void 0 ? void 0 : opt.disable_webp) &&
                this.support_webp) {
                urlStr += "".concat(default_suffix).concat(extend_suffix);
            }
            else if ("".concat(default_suffix) != '.webp') {
                urlStr += "".concat(default_suffix).concat(extend_suffix);
            }
            return {
                ok: true,
                url: urlStr
            };
        }
    };
    ENDPOINT.prototype.getImgHttpsUrl = function (biz, imgid, suffix, opt) {
        if (suffix === void 0) { suffix = ''; }
        var res = this.getImgUrl(biz, imgid, suffix, opt);
        if (res.ok) {
            res.url = res.url.replace('http://', 'https://');
        }
        return res;
    };
    ENDPOINT.prototype.getImgHttpsUrlV2 = function (biz, imgid, suffix, opt) {
        if (suffix === void 0) { suffix = ''; }
        var res = this.getImgUrlV2(biz, imgid, suffix, opt);
        if (res.ok) {
            res.url = res.url.replace('http://', 'https://');
        }
        return res;
    };
    ENDPOINT.prototype.downloadImg = function (biz, imgid, suffix, name) {
        var _this = this;
        if (suffix === void 0) { suffix = ''; }
        if (name === void 0) { name = ''; }
        return new Promise(function (resolve, reject) {
            var res = _this.getImgUrl(biz, imgid, suffix);
            if (res.ok) {
                var image_1 = new Image();
                image_1.setAttribute('crossOrigin', 'anonymous');
                image_1.src = res.url;
                image_1.onload = function () {
                    if (image_1.width > 0 && image_1.height > 0) {
                        console.log(image_1.width, 222);
                        console.log(image_1.height, 222);
                        // const a = document.createElement('a')
                        // a.href = res.url
                        // a.download = name || imgid
                        // a.click()
                        // a.dispatchEvent(new MouseEvent('click'))
                        // a.remove() // 用完释放a标签
                        var canvas = document.createElement('canvas');
                        canvas.width = image_1.width;
                        canvas.height = image_1.height;
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(image_1, 0, 0, image_1.width, image_1.height);
                        canvas.toBlob(function (blob) {
                            var url = URL.createObjectURL(blob);
                            var a = document.createElement('a');
                            a.download = name || imgid;
                            a.href = url;
                            a.click();
                            // 用完释放URL对象和a标签
                            a.remove();
                            URL.revokeObjectURL(url);
                        });
                        resolve(true);
                    }
                    else {
                        resolve(false);
                    }
                };
                image_1.onerror = function (err) {
                    console.log('error===', err);
                    reject(false);
                };
            }
            else {
                reject(false);
            }
        });
    };
    ENDPOINT.prototype.getDataBy = function (key) {
        if (this._strategy[key]) {
            return this._strategy[key];
        }
        else {
            return {
                ok: false,
                data: {}
            };
        }
    };
    // 获取当前biz下的策略信息
    ENDPOINT.prototype.getStrategy = function () {
        this.fetchStrategy('endpoint_strategy');
        var biz = this.options.biz;
        var _strategy = (window.localStorage &&
            JSON.parse(localStorage.getItem('endpoint_strategy'))) ||
            utils_1.defaultStrategy;
        var ver = _strategy.ver, endpoint_cron = _strategy.endpoint_cron, _a = _strategy.mms_image.data, api_timeout = _a.api_timeout, configs = _a.configs;
        return {
            ver: ver,
            api_timeout: api_timeout,
            endpoint_cron: endpoint_cron,
            configs: configs[biz] || configs[100] // 默认使用biz为100的配置
        };
    };
    ENDPOINT.lock = false;
    return ENDPOINT;
}());
exports.ENDPOINT = ENDPOINT;
